import styled from "styled-components";

const UserListItem = styled(({ className, caseLead }) => {
  return (
    <div className={className}>
      <div className="label">{caseLead.full_name}</div>
      <div className="detail">{caseLead.title}</div>
      <div className="detail">{caseLead.email}</div>
    </div>
  );
})`
  width: 100%;
  line-height: 1.25;

  .label {
    font-weight: 450;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .detail {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.palette.text.secondary};
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export default UserListItem;
